import {
  SWRInfiniteConfiguration,
  SWRInfiniteResponse,
} from 'swr/infinite/dist/infinite'

export const asInfinite =
  <T, V>(
    useFn: (
      param: T,
      pageSize: number,
      config?: SWRInfiniteConfiguration,
    ) => SWRInfiniteResponse<V[], any>,
  ) =>
  (param: T, pageSize: number, config?: SWRInfiniteConfiguration) => {
    const values = useFn(param, pageSize, config)
    const { data, error, isValidating, setSize, size } = values

    const isLoadingInitialData = !data && !error
    const isEmpty = data && data[0]?.length === 0
    const isReachingEnd = isEmpty || (data && !data[data.length - 1].length)
    const canFetchMore =
      !isLoadingInitialData && !isValidating && !isReachingEnd

    const fetchMore = canFetchMore ? () => setSize(size + 1) : undefined
    return {
      ...values,
      isLoadingInitialData,
      isEmpty,
      isReachingEnd,
      fetchMore,
    }
  }
